export default __webpack_public_path__ + "static/js/preflightWorker.3bd80aeeff7dc00557ce.worker.js";